import AgileAltLogo from "../assets/agile-alt-lockup.svg";
import AgileAppIcon from "../assets/agile-app-icon.svg";
import AgilePollyLogoMobile from "../assets/agile-polly-logo-only.svg";
import AgilePollyLogoWhite from "../assets/agile-polly-logo-white.svg";
import AgilePollyLogo from "../assets/agile-polly-logo.svg";
import CoreAltLogo from "../assets/core-alt-lockup.svg";
import CoreAppIcon from "../assets/core-app-icon.svg";
import CoreLogoWhite from "../assets/polly-tab-logo-lockup-white-text.svg";
import CoreLogoDefault from "../assets/polly-tab-logo-lockup.svg";
import { getPageContext } from "./teamsHelpers";

export const getAppTitleFromPageContext = () => {
  const pageContext = getPageContext();
  switch (pageContext) {
    case "/agile":
      return "AgilePolly";
    default:
      return "Polly";
  }
};

export const getLogoFromPageContext = (themeName: string, isMobile: boolean) => {
  const pageContext = getPageContext();
  switch (pageContext) {
    case "/agile":
      if (isMobile) {
        return AgilePollyLogoMobile;
      }
      return themeName === "default" ? AgilePollyLogo : AgilePollyLogoWhite;
    default:
      return themeName === "default" ? CoreLogoDefault : CoreLogoWhite;
  }
};

export const getAltLogoFromPageContext = () => {
  const pageContext = getPageContext();
  switch (pageContext) {
    case "/agile":
      return AgileAltLogo;
    default:
      return CoreAltLogo;
  }
};

export const getAppIconFromPageContext = () => {
  const pageContext = getPageContext();
  switch (pageContext) {
    case "/agile":
      return AgileAppIcon;
    default:
      return CoreAppIcon;
  }
};
